module.exports = __webpack_public_path__ + "img/alfred.f0fc4af0.svg";